"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustBeDivisibleBy = void 0;
const is_number_1 = require("../../functions/is-number/is-number");
const parse_number_1 = require("../../functions/parse-number/parse-number");
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for numbers that need to be divisible by a certain divisor (e.g. 2 for even ones).
 *
 * Creates a `Validation` for numbers that need to be divisible by a certain divisor. If the fields contain any value,
 * validates that the value is greater than or equal to the given lower bound. It does not matter for this validation
 * if the given value is a number or string type.
 *
 * Note: This validation will also succeed on empty values and other string values. If a value must be given,
 * use the `isRequired` validation. If a number must be given, use the `mustContainNumber` validation.
 *
 * @param divisor The number the value should be divisible by.
 * @param message The message to be displayed of the validation failed. If left undefined, an English fallback will be used.
 *
 * @see Validation
 */
function mustBeDivisibleBy(divisor, message) {
    return (0, validation_1.validation)(message ?? `The given value must be divisible by ${divisor}.`, (value) => {
        if (typeof value === 'string')
            return !(0, is_number_1.isNumber)(value) || !divisor || !((0, parse_number_1.parseNumber)(value) % divisor);
        return value == null || !divisor || !(value % divisor);
    });
}
exports.mustBeDivisibleBy = mustBeDivisibleBy;
